import { render, staticRenderFns } from "./OrderStatusList.vue?vue&type=template&id=532f1250&scoped=true&"
import script from "./OrderStatusList.vue?vue&type=script&lang=js&"
export * from "./OrderStatusList.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusList.vue?vue&type=style&index=0&id=532f1250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532f1250",
  null
  
)

component.options.__file = "OrderStatusList.vue"
export default component.exports